<!-- 
    描述： 收款账户设置
    时间： 2020/11/3
    Created by zl
-->
<template>
    <div class="h100 pay-setting">
        <div class="h100">
            <el-card class="h100">
                <div slot="header">账户信息</div>
                <div v-if="this.payData.length <= 0" class="no-data">
                    <div>
                        <img src="@/assets/images/no-msg.png" alt="" />
                    </div>
                    <el-button
                        type="primary"
                        class="btn-blue add-btn"
                        @click="openDialog"
                        icon="el-icon-plus"
                        >添加收款账户</el-button
                    >
                </div>
                <div v-else class="have-data">
                    <el-form label-width="180px">
                        <el-form-item label="添加收款账户：">
                            <div>
                                <span v-if="this.msgTip && this.msgTip != ''">{{
                                    this.msgTip
                                }}</span>
                                <span
                                    v-if="this.yyzzTip && this.yyzzTip != ''"
                                    >{{ this.yyzzTip }}</span
                                >
                                <span v-if="this.zfTip && this.zfTip != ''">{{
                                    this.zfTip
                                }}</span>
                                <span
                                    v-if="
                                        this.agreementTip &&
                                        this.agreementTip != ''
                                    "
                                    >{{ this.agreementTip }}</span
                                >
                            </div>
                            <div
                                class="item"
                                v-for="(item, index) in payData"
                                :key="'payData' + index"
                            >
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="企业名称："
                                            required
                                        >
                                            <el-input
                                                v-model="item.sname"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="统一社会信用机构代码："
                                            required
                                        >
                                            <el-input
                                                v-model="item.code"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="法人代表姓名："
                                            required
                                        >
                                            <el-input
                                                v-model="item.legaler"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="法人代表身份证："
                                            required
                                        >
                                            <el-input
                                                v-model="item.idCard"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="法人代表手机号："
                                            required
                                        >
                                            <el-input
                                                v-model="item.legalPhone"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="开户行：" required>
                                            <el-input
                                                v-model="item.bank"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="对公账户："
                                            required
                                        >
                                            <el-input
                                                v-model="item.account"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="开户行支行名称："
                                            required
                                        >
                                            <el-input
                                                v-model="item.branchBank"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="支付行号："
                                            required
                                        >
                                            <el-input
                                                v-model="item.payNo"
                                                disabled
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="统一社会机构代码："
                                            required
                                        >
                                            <div class="flex check">
                                                <upload
                                                    ref="codeUpload"
                                                    tableName="operate_account"
                                                    assortment="code"
                                                    listType="picture-card"
                                                    :aid="item.id"
                                                    :maxNum="1"
                                                    :hideTip="true"
                                                    :isDisabled="true"
                                                ></upload>
                                                <span
                                                    v-if="checkState"
                                                    class="green"
                                                >
                                                    √ 已通过认证</span
                                                >
                                                <span v-else class="checking"
                                                    >审核中</span
                                                >
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="法人身份证复印件："
                                            required
                                        >
                                            <div class="flex">
                                                <upload
                                                    ref="idCardZ"
                                                    tableName="operate_account"
                                                    assortment="idCardZ"
                                                    listType="picture-card"
                                                    :aid="item.id"
                                                    :maxNum="1"
                                                    :isDisabled="true"
                                                    msg="idCardZ"
                                                    :hideTip="false"
                                                ></upload>
                                                <upload
                                                    ref="idCardF"
                                                    tableName="operate_account"
                                                    assortment="idCardF"
                                                    listType="picture-card"
                                                    :aid="item.id"
                                                    :maxNum="1"
                                                    :hideTip="false"
                                                    :isDisabled="true"
                                                    msg="idCardF"
                                                    class="ml10"
                                                ></upload>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-row class="mb20">
                                <el-button
                                    class="fl add-style"
                                    type="text"
                                    size="small"
                                    icon="el-icon-setting"
                                    @click="openDialog"
                                    v-if="!checkState"
                                >
                                    修改账户信息
                                </el-button>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </div>

        <el-dialog
            :title="dialogObj.title"
            :visible.sync="dialogVisible"
            width="70%"
            class="addPay"
            center
            @closed="cancel"
        >
            <add-dialog
                :num="sumNum"
                @openDia="openTemplate"
                @getSumbit="getSumbit"
                :bizUserId="userId"
                @openA="openA"
                :objPay="objPay"
                ref="addDia"
            ></add-dialog>
            <div slot="footer">
                <div>
                    <el-button
                        type="primary"
                        size="small"
                        class="btn-blue"
                        @click="next"
                        v-if="sumNum == 0"
                        :loading="loading"
                        >下一步</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        class="btn-blue"
                        @click="confirm"
                        v-if="sumNum == 1"
                        :disabled="sumbit"
                        >提交</el-button
                    >
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 查看模板 -->
        <el-dialog
            :visible.sync="visibleImg"
            title="图片预览"
            width="800px"
            class="addPay"
            center
        >
            <div class="tempalte-img">
                <img src="@/assets/images/template.jpg" alt="" />
            </div>
        </el-dialog>

        <!-- 查看模板 -->
        <el-dialog
            :visible.sync="visibleUrl"
            title="通联支付网络交易资金管理服务三方协议"
            width="80%"
            class="addPay"
            @closed="closeMsg"
            center
        >
            <iframe
                :src="openUrl"
                frameborder="0"
                height="100%"
                width="100%"
            ></iframe>
        </el-dialog>
    </div>
</template>
<script>
import addDialog from './components/add-payUser-dialog'
import upload from './components/upload'
import {
    setCompanyMember,
    setCompanyInfo,
    bindPhone,
    getApplyRecordResult,
    sendVerificationCode,
    saveAccount,
    accountVerify,
    saveApplyRecord,
    pictureCollect,
    signContract,
    selectDeptByUserId,
} from 'api/modules/paymentSettlement'
import { dateFormat } from 'utils/tools'
export default {
    name: 'Payment-settlement',
    components: {
        addDialog,
        upload,
    },
    props: {},
    data() {
        return {
            dialogVisible: false,
            payData: [],
            dialogObj: {
                title: '添加收款账户',
            },
            sumNum: 0,
            visibleImg: false,
            userId: '',
            hyId: '',
            loading: false,
            sumbit: true,
            openUrl: '',
            visibleUrl: false,
            accountId: '',
            objPay: {},
            msgTip: '',
            yyzzTip: '',
            zfTip: '',
            agreementTip: '',
            checkState: true,
        }
    },
    mounted() {
        this.selectDeptByUserId()
    },
    methods: {
        // 获取账户信息
        echoAccount(id) {
            accountVerify({
                id,
            }).then((d) => {
                if (d.operationCode == 1) {
                    if (d.data.list) {
                        console.log('112')
                        this.objPay = d.data
                        this.payData = []
                        this.payData.push(d.data)
                        this.userId = d.data.bizUserid
                        this.hyId = d.data.id
                        this.objPay.list.forEach((item) => {
                            switch (item.type) {
                                case 0:
                                    item.state == 2
                                        ? (this.msgTip =
                                              '账户信息信息审核没通过,请审核后重新上传')
                                        : (this.checkState = false)
                                    break
                                case 1:
                                    item.state == 2
                                        ? (this.yyzzTip =
                                              '营业执照审核没通过,请删除之前的图片后重新上传')
                                        : (this.checkState = false)
                                    break
                                case 2:
                                    item.state == 2
                                        ? (this.zfTip =
                                              '身份证证件审核没通过,请删除之前的图片后重新上传')
                                        : (this.checkState = false)
                                    break
                                case 3:
                                    item.state == 2
                                        ? (this.agreementTip =
                                              '电子签约审核没通过,请审核后重新签约')
                                        : (this.checkState = false)
                                    break
                            }
                        })
                    } else {
                        this.userId = d.data.bizUserid
                        this.hyId = d.data.id
                    }
                }
            })
        },

        // 下一步
        next() {
            let codeList = this.$refs.addDia.$refs.codeUpload.addList
            let zList = this.$refs.addDia.$refs.idCardZ.addList
            let fList = this.$refs.addDia.$refs.idCardF.addList
            if (this.objPay.id) {
            } else {
                this.$refs.addDia.$refs.payRef.validate((valid) => {
                    if (valid) {
                        let params = Object.assign({}, this.$refs.addDia.payObj)
                        params.memberId = this.hyId
                        // 保存账户 -- 账户表
                        saveAccount(params).then((d) => {
                            // 账户 id 用来保存记录
                            this.accountId = d.data.id
                            let params1 = Object.assign(
                                {},
                                this.$refs.addDia.payObj
                            )
                            params1.bizUserId = this.userId
                            // 设置企业信息
                            setCompanyInfo(params1).then((d) => {
                                if (d.code == 0) {
                                    this.loading = true
                                    let msg = this.$message({
                                        type: 'warning',
                                        message: '审核中，请稍等！',
                                        duration: 0,
                                    })
                                    // 保存记录 -- 记录表
                                    this.saveApplyRecord(this.accountId, '0')

                                    // 上传影印件
                                    if (
                                        codeList.length < 1 ||
                                        zList.length < 1 ||
                                        fList.length < 1
                                    ) {
                                        this.$message.error('请上传影印件！')
                                    } else {
                                        this.dealPicture(
                                            this.userId,
                                            this.accountId,
                                            '1',
                                            codeList[0]
                                        )
                                        this.dealPicture(
                                            this.userId,
                                            this.accountId,
                                            '2',
                                            zList[0]
                                        )
                                        this.dealPicture(
                                            this.userId,
                                            this.accountId,
                                            '3',
                                            fList[0]
                                        )
                                        this.savaImg(this.accountId)
                                        // 两秒后调用 查询审核结果
                                        setTimeout(() => {
                                            getApplyRecordResult({
                                                bizUserId: this.userId,
                                                type: '0'
                                            }).then(d => {
                                                if(d.data.state == 1){
                                                    msg.close()
                                                    this.loading = false
                                                    this.sumNum++
                                                }else {
                                                    this.dialogVisible = false
                                                    this.$message.warning('审核中请稍后')
                                                }
                                            })
                                        },2000)
                                    }
                                }
                            })
                        })
                    } else {
                        this.$message.error('请校验表单')
                    }
                })
            }
            this.dealTitle(this.sumNum)
        },

        // 获取当前用户信息
        selectDeptByUserId() {
            selectDeptByUserId().then((d) => {
                if (d.operationCode == 1) {
                    this.echoAccount(d.data.id)
                }
            })
        },

        // 打开添加收款账户
        openDialog() {
            this.dialogVisible = true
            if (this.$refs.addDia) {
                this.$refs.addDia.selectDeptByUserId()
            }
        },

        // 打开机构代码证模板
        openTemplate() {
            this.visibleImg = true
        },

        // 取消
        cancel() {
            this.dialogVisible = false
            this.selectDeptByUserId()
            this.sumNum = 0
        },

        // 确认
        confirm() {
            let params = this.$refs.addDia.phoneForm
            let accountId = ''
            if (this.objPay.id) {
                accountId = this.objPay.id
                if (this.objPay.list[3] && this.objPay.list[3].state == 1) {
                    this.sumNum = 0
                    this.dialogVisible = false
                } else {
                    params.bizUserId = this.objPay.bizUserid
                    this.saveApplyRecord(accountId, '4')
                    sendVerificationCode(params).then((d) => {
                        if (d.code == 0) {
                            signContract({
                                bizUserId: this.objPay.bizUserid,
                                type: '',
                            }).then((d) => {
                                this.openUrl = d.data
                                this.visibleUrl = true
                            })
                        }
                    })
                }
            } else {
                params.bizUserId = this.userId
                accountId = this.accountId
                this.$refs.addDia.$refs.phoneRef.validate((valid) => {
                    if (valid) {
                        sendVerificationCode(params).then((d) => {
                            if (d.code == 0) {
                                let url = encodeURI(window.location.href)
                                signContract({
                                    bizUserId: this.userId,
                                    jumpUrl: url,
                                }).then((d) => {
                                    this.openUrl = d.data
                                    this.visibleUrl = true
                                })
                            }
                        })
                        this.saveApplyRecord(accountId, '4')
                    }
                })
            }
        },

        // 保存一条记录
        saveApplyRecord(id, type) {
            saveApplyRecord({
                accountId: id,
                type,
            }).then((d) => {})
        },

        // 获取审核结果
        getApplyRecordResult(id, type) {
            getApplyRecordResult({
                accountId: id,
                type,
            }).then((d) => {})
        },

        // 影印件上传审核
        pictureCollect(id, type, list) {
            let formData = new FormData()
            formData.append('file', list)
            formData.append('path', dateFormat('yyyy-mm-dd'))
            formData.append('output', 'json')
            formData.append('bizUserId', id)
            formData.append('picType', type)
            pictureCollect(formData).then((d) => {})
        },

        // 影印件三步处理
        dealPicture(id, accountId, type, list) {
            this.pictureCollect(id, type, list)
            if (type != '3') {
                this.saveApplyRecord(accountId, type)
            }
        },

        // 本地保存影印件
        savaImg(id) {
            this.$refs.addDia.$refs.codeUpload.fileSend(id)
            this.$refs.addDia.$refs.idCardZ.fileSend(id)
            this.$refs.addDia.$refs.idCardF.fileSend(id)
        },

        // 处理标题
        dealTitle(num) {
            switch (num) {
                case 0:
                    this.dialogObj.title = '添加收款账户'
                    break
                case 1:
                    this.dialogObj.title = '手机号验证'
                    break
                case 2:
                    this.dialogObj.title =
                        '通联支付网络交易资金管理服务三方协议'
                    break
            }
        },

        // 统一协议才能提交
        getSumbit(data) {
            this.sumbit = !data
        },

        // 打开协议
        openA() {
            // let url = encodeURI(window.location.href)
            if (this.objPay.id) {
                signContract({
                    bizUserId: this.objPay.bizUserid,
                }).then((d) => {
                    this.openUrl = d.data
                    this.visibleUrl = true
                })
            } else {
                signContract({
                    bizUserId: this.userId,
                }).then((d) => {
                    this.openUrl = d.data
                    this.visibleUrl = true
                })
            }
        },

        // 关闭
        closeMsg() {
            if (this.objPay.id) {
                getApplyRecordResult({
                    accountId: this.objPay.id,
                    type: '4',
                }).then((d) => {
                    if (d.data.state == 1) {
                        this.dialogVisible = false
                        this.sumNum = 0
                    } else {
                        this.$message.error('电子签约审核中')
                    }
                })
            } else {
                getApplyRecordResult({
                    accountId: this.accountId,
                    type: '4',
                }).then((d) => {
                    if (d.data.state == 1) {
                        this.dialogVisible = false
                        this.sumNum = 0
                    } else {
                        this.$message.error('电子签约审核中')
                    }
                })
            }
        },
    },
    computed: {},
}
</script>
<style lang='less' scoped>
.pay-setting {
    padding: 10px;
    /deep/ .el-card__header {
        padding: 0;
        div {
            height: 40px;
            line-height: 40px;
            padding: 0 15px;
            font-size: 14px;
            color: #202020;
            background-color: #dcdfe6;
        }
    }
    /deep/ .el-card__body {
        height: 100%;
        text-align: center;
        overflow-y: auto;
        padding-bottom: 50px;
    }
    .el-button {
        width: 120px !important;
        height: 40px;
    }
    .add-btn {
        width: 194px !important;
        margin-top: 70px;
    }
    .el-form-item {
        margin-bottom: 10px !important;
    }
    .item {
        background-color: #f2f6fc;
        padding: 30px 48px 30px 0;
        margin-bottom: 30px;
    }
    .add-style {
        /deep/ i {
            font-size: 20px;
        }
        /deep/ span {
            vertical-align: text-top;
        }
        color: #202020;
        border: none;
    }
    .add-style:hover {
        color: #256ccb;
    }
    .leftM {
        margin-left: 180px;
    }
    .check {
        justify-content: space-between;
        color: #fff;
        .green {
            display: inline-block;
            width: 100px;
            height: 40px;
            line-height: 40px;
            background-color: rgba(0, 153, 0, 1);
        }
        .checking {
            display: inline-block;
            width: 100px;
            height: 40px;
            line-height: 40px;
            background-color: rgba(255, 204, 0, 1);
        }
    }
}
</style>

<style lang="less">
.addPay {
    .el-dialog__header {
        background-color: #2671cc;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__close {
            color: #fff;
            font-size: 24px;
            font-weight: bold;
        }
    }
    .el-dialog__body {
        max-height: 630px;
        height: 630px;
    }
    .tempalte-img {
        text-align: center;
        img {
            width: 480px;
            height: 539px;
            border: 1px solid #eee;
        }
    }
}
</style>
